<template>
  <div>
    <el-card class="card_page">
      <el-row class="zone_config__title">分区配置</el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="功能分区配置" name="first">
          <!-- 搜索 -->
          <el-row class="zone_config__search">
            <span>类型</span>
            <el-select
              v-model="searchInfo.zoneType"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in typeCon"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span>渠道</span>
            <el-select
              v-model="searchInfo.channel"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="item.channelId"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="getConfigList"
              >搜索</el-button
            >
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="
                () => {
                  configType = 0
                  configDialog = true
                }
              "
              >添加</el-button
            >
          </el-row>
          <!-- 表格 -->
          <el-row>
            <el-table border :data="table">
              <el-table-column prop="id" label="id" align="center">
              </el-table-column>
              <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                  {{
                    typeCon.find((item) => item.value === scope.row.zoneType)
                      .name
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="channel" label="渠道" align="center">
              </el-table-column>
              <el-table-column label="配置内容" align="center">
                <template slot-scope="scope">
                  <p
                    style="color: #49c0f5; cursor: pointer"
                    @click="getDetail(scope.row.id, scope.row.zoneType)"
                  >
                    详细内容
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="有效值" align="center">
                <template slot-scope="scope">
                  {{ scope.row.valid === 0 ? '无效' : '有效' }}
                </template>
              </el-table-column>
              <el-table-column prop="operator" label="操作人" align="center">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="fixDate" label="修改时间" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" @click="updateConfig(scope.row)"
                    >修改</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="分区标签配置" name="second">
          <!-- 搜索 -->
          <el-row class="zone_config__search">
            <span>地区标签：</span>
            <el-select
              v-model="labelSearch.zoneLabelId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in nameCon"
                :key="index"
                :label="item.zoneLabelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="getLabelList"
              >搜索</el-button
            >
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="
                () => {
                  labelType = 0
                  labelDialog = true
                }
              "
              >添加</el-button
            >
          </el-row>
          <!-- 表格 -->
          <el-row>
            <el-table border :data="labelTable">
              <el-table-column prop="id" label="id" align="center">
              </el-table-column>
              <el-table-column
                prop="zoneLabelName"
                label="地区标签名"
                align="center"
              >
              </el-table-column>
              <el-table-column label="国家" align="center">
                <template slot-scope="scope">
                  {{ scope.row.countryList.toString() }}
                </template>
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="fixDate" label="修改时间" align="center">
              </el-table-column>
              <el-table-column
                prop="operator"
                label="操作人"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" @click="updateLabel(scope.row)"
                    >修改</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <!-- 弹窗 -->
          <el-dialog
            :show-close="false"
            :close-on-click-modal="false"
            :visible.sync="labelDialog"
            :close-on-press-escape="false"
            title="分区地区配置"
            class="config"
          >
            <el-row>
              <span>地区标签名:</span>
              <el-input
                v-model="labelForm.zoneLabelName"
                style="width: 250px"
              ></el-input>
            </el-row>
            <el-row v-if="labelType === 1">
              <span>有效值：</span>
              <el-switch
                v-model="labelForm.valid"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-row>
            <el-row>
              <span>国家：</span>
              <el-select
                filterable
                allow-create
                default-first-option
                placeholder="请选择"
                v-model="b"
                @change="add"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.countryCode"
                  :label="item.country"
                  :value="item.countryCode"
                >
                </el-option>
              </el-select>
              <el-row class="country">
                <div
                  class="item"
                  v-for="(item, index) in labelForm.countryList"
                  :key="index"
                >
                  <p>{{ item }}</p>
                  <div @click="labelForm.countryList.splice(index, 1)">x</div>
                </div>
              </el-row>
            </el-row>
            <el-row>
              <el-button @click="resetForm(3)">取消</el-button>
              <el-button type="primary" @click="labelSubmit">确认</el-button>
            </el-row>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
      <!-- 弹窗 -->
      <el-dialog
        :show-close="false"
        :close-on-click-modal="false"
        :visible.sync="configDialog"
        :close-on-press-escape="false"
        title="分区配置管理"
        class="config"
      >
        <el-row>
          <span>类型:</span>
          <el-select
            v-model="form.zoneType"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in typeCon"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <span>渠道:</span>
          <el-select
            v-model="form.channel"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in channelList"
              :key="item.channelId"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row v-if="configType === 1">
          <span>有效值:</span>
          <el-switch
            v-model="form.valid"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-row>
        <el-row>
          <el-button @click="resetForm(0)">取消</el-button>
          <el-button type="primary" @click="submit">确认</el-button>
        </el-row>
      </el-dialog>
    </el-card>
    <el-card class="card_page" v-if="activeName === 'first' && detailId">
      <el-row class="zone_config__title">分区详情配置</el-row>
      <!-- 搜索 -->
      <el-row class="zone_config__search">
        <el-button
          style="margin-left: 10px"
          type="success"
          @click="
            () => {
              detailType = 0
              detailDialog = true
            }
          "
          >添加</el-button
        >
      </el-row>
      <!-- 表格 -->
      <el-row>
        <el-table border :data="detailTable">
          <el-table-column prop="id" label="id" align="center">
          </el-table-column>
          <el-table-column
            :label="justCountry == 2 ? '全球' : '仅国家'"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.global === 0 ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column label="国家" align="center">
            <template slot-scope="scope">
              {{ scope.row.countryList.toString() }}
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="权重" align="center">
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center">
          </el-table-column>
          <el-table-column prop="fixDate" label="修改时间" align="center">
          </el-table-column>
          <el-table-column
            prop="operator"
            label="操作人"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="updateDetail(scope.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 弹窗 -->
      <el-dialog
        :show-close="false"
        :close-on-click-modal="false"
        :visible.sync="detailDialog"
        :close-on-press-escape="false"
        title="分区详情管理"
        class="config"
      >
        <el-row>
          <span>权重:</span>
          <el-input
            style="width: 200px"
            v-model.number="detailForm.weight"
            type="number"
          ></el-input>
        </el-row>
        <el-row>
          <span>全球:</span>
          <el-switch
            v-model="detailForm.global"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-row>
        <el-row>
          <span>有效值:</span>
          <el-switch
            v-model="detailForm.valid"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-row>
        <el-row>
          <span>国家:</span>
          <el-select
            filterable
            allow-create
            default-first-option
            placeholder="请选择"
            v-model="a"
            @change="adds"
          >
            <el-option
              v-for="item in countryList"
              :key="item.countryCode"
              :label="item.country"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
          <span>地区标签：</span>
          <el-select
            v-model="c"
            clearable
            filterable
            placeholder="请选择"
            @change="changes"
          >
            <el-option
              v-for="(item, index) in nameCon"
              :key="index"
              :label="item.zoneLabelName"
              :value="index"
            >
            </el-option>
          </el-select>
          <!-- <el-row class="country">
            <el-row
              class="item"
              v-for="(item, index) in detailForm.countryList"
              :key="index"
            >
              <el-input
                style="width: 200px"
                v-model="detailForm.countryList[index]"
              ></el-input>
              <el-button
                style="margin-left: 15px"
                type="danger"
                icon="el-icon-delete"
                circle
                @click="detailForm.countryList.splice(index, 1)"
              ></el-button>
            </el-row>
          </el-row> -->
          <!-- <el-button
            icon="el-icon-plus"
            circle
            @click="detailForm.countryList.push('')"
          ></el-button> -->
          <el-row class="country">
            <div
              class="item"
              v-for="(item, index) in detailForm.countryList"
              :key="index"
            >
              <p>{{ item }}</p>
              <div @click="detailForm.countryList.splice(index, 1)">x</div>
            </div>
          </el-row>
        </el-row>
        <el-row>
          <el-button @click="resetForm(1)">取消</el-button>
          <el-button type="primary" @click="detailSubmit">确认</el-button>
        </el-row>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  getZonTypeCon,
  getZonTypeList,
  getZonTypeAdd,
  getZonTypeChange,
  getZonConfigQuery,
  getZonConfigAdd,
  getZonConfigChange,
  getZonNameList,
  getZonLabelList,
  getZonLabelAdd,
  getZonLabelChange,
} from '@/api/zoneConfig'
export default {
  data() {
    return {
      activeName: 'first',
      configDialog: false,
      detailDialog: false,
      labelDialog: false,
      a: null,
      b: null,
      c: null,
      // 0 是添加 1 是修改
      configType: 0,
      detailType: 0,
      labelType: 0,
      typeCon: [],
      nameCon: [],
      countryList: [],
      detailId: null,
      searchInfo: {
        channel: null,
        zoneType: null,
      },
      labelSearch: {
        zoneLabelId: null,
      },
      form: {
        zoneType: null,
        channel: null,
        valid: 1,
      },
      detailForm: {
        weight: null,
        global: 0,
        valid: 0,
        countryList: [],
      },
      labelForm: {
        zoneLabelName: null,
        countryList: [],
        valid: 0,
      },
      justCountry: 2,
      table: [],
      labelTable: [],
      detailTable: [],
      channelList: [],
    }
  },
  mounted() {
    this.getAllInfo()
  },
  methods: {
    changes(index) {
      console.log(index)
      // console.log(this.nameCon)
      this.detailForm.countryList = this.nameCon[index].countryList
    },
    add(info) {
      console.log(info)
      this.labelForm.countryList.push(info)
    },
    adds(info) {
      this.detailForm.countryList.push(info)
    },
    handleClick(tab) {
      if (tab.index === 0) {
        this.getConfigList()
      } else {
        this.getZonName()
        this.getLabelList()
      }
    },
    getAllInfo() {
      this.getTypeCon()
      this.getConfigList()
      this.getChannel()
      this.getCountryCode()
      this.getZonName()
    },
    // 获取配置类型
    async getTypeCon() {
      const res = await getZonTypeCon()
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.typeCon = res.data
      }
    },
    async getZonName() {
      const res = await getZonNameList()
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.nameCon = res.data
      }
    },
    // 获取配置列表
    async getConfigList() {
      const res = await getZonTypeList(this.searchInfo)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.table = res.data
      }
    },
    // 获取分区列表
    async getLabelList() {
      const res = await getZonLabelList(this.labelSearch)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.labelTable = res.data
      }
    },
    // 添加配置
    async addConfig() {
      const info = {
        zoneType: +this.form.zoneType,
        channel: this.form.channel,
      }
      const res = await getZonTypeAdd(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(0)
        this.getConfigList()
        this.$message.success('添加成功')
      }
    },
    // 添加详情配置
    async addDetail() {
      const info = {
        zoneTypeId: +this.detailId,
        weight: +this.detailForm.weight,
        global: +this.detailForm.global,
        valid: +this.detailForm.valid,
        countryList:
          this.detailForm.countryList.length > 0
            ? this.detailForm.countryList
            : null,
      }
      const res = await getZonConfigAdd(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(1)
        this.getDetail(this.detailId)
        this.$message.success('添加成功')
      }
    },
    // 添加分区配置
    async addLabel() {
      const info = {
        zoneLabelName: this.labelForm.zoneLabelName,
        countryList:
          this.labelForm.countryList.length > 0
            ? this.labelForm.countryList
            : null,
      }
      const res = await getZonLabelAdd(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(3)
        this.getLabelList()
        this.$message.success('添加成功')
      }
    },
    // 获取详细
    async getDetail(zoneTypeId, type) {
      this.id = zoneTypeId
      this.justCountry = type === 3 ? '1' : '2'
      const res = await getZonConfigQuery(zoneTypeId)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.detailId = zoneTypeId
        this.detailTable = res.data
      }
    },
    // 修改配置提交
    async changeConfig() {
      const info = {
        id: +this.form.id,
        zoneType: +this.form.zoneType,
        channel: this.form.channel,
        valid: +this.form.valid,
      }
      const res = await getZonTypeChange(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(0)
        this.getConfigList()
        this.$message.success('修改成功')
      }
    },
    // 修改详情提交
    async changeDetail() {
      const info = {
        zoneTypeId: +this.detailId,
        zoneObjectId: this.detailForm.zoneObjectId,
        weight: +this.detailForm.weight,
        global: +this.detailForm.global,
        valid: +this.detailForm.valid,
        countryList:
          this.detailForm.countryList.length > 0
            ? this.detailForm.countryList
            : null,
      }
      const res = await getZonConfigChange(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(1)
        this.getDetail(this.detailId)
        this.$message.success('修改成功')
      }
    },
    // 修改分区提交
    async changeLabel() {
      const info = {
        id: +this.labelForm.id,
        zoneLabelName: this.labelForm.zoneLabelName,
        valid: +this.labelForm.valid,
        countryList:
          this.labelForm.countryList.length > 0
            ? this.labelForm.countryList
            : null,
      }
      const res = await getZonLabelChange(info)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.resetForm(3)
        this.getLabelList()
      }
    },
    // 修改配置
    updateConfig(info) {
      this.configType = 1
      console.log(info)
      this.form.id = info.id
      this.form.valid = info.valid
      this.form.channel = info.channel
      this.form.zoneType = info.zoneType
      this.configDialog = true
    },
    // 修改详情
    updateDetail(info) {
      this.detailType = 1
      this.detailForm.zoneObjectId = info.zoneObjectId
      this.detailForm.weight = info.weight
      this.detailForm.global = info.global
      this.detailForm.valid = info.valid
      this.detailForm.countryList = info.countryList
      this.detailDialog = true
    },
    // 修改分区
    updateLabel(info) {
      this.labelType = 1
      this.labelForm.id = info.id
      this.labelForm.zoneLabelName = info.zoneLabelName
      this.labelForm.valid = info.valid
      this.labelForm.countryList = info.countryList
      this.labelDialog = true
    },
    // 取消
    resetForm(type) {
      if (type === 0) {
        this.form = {
          zoneType: null,
          channel: null,
          valid: 1,
        }
        this.configDialog = false
      } else if (type === 1) {
        this.detailForm = {
          weight: null,
          global: 0,
          valid: 0,
          countryList: [],
        }
        this.c = null
        this.detailDialog = false
      } else {
        this.labelForm = {
          zoneLabelName: null,
          countryList: [],
          valid: 0,
        }
        this.labelDialog = false
      }
      this.a = null
      this.b = null
    },
    // 提交
    async submit() {
      if (this.configType === 0) {
        this.addConfig()
      } else {
        this.changeConfig()
      }
    },
    // 详细提交
    async detailSubmit() {
      if (this.detailType === 0) {
        this.addDetail()
      } else {
        this.changeDetail()
      }
      this.getAllInfo()
    },
    // 分区提交
    async labelSubmit() {
      if (this.labelType === 0) {
        this.addLabel()
      } else {
        this.changeLabel()
      }
    },
    // 获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
  },
}
</script>

<style scoped lang="scss">
.zone_config {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.country {
  width: 100%;
  border: 1px solid #ccc;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  gap: 10px;

  .item {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    background: #1e98d7;
    color: #fff;
    border-radius: 30px;
    position: relative;
    > div {
      position: absolute;
      right: -5px;
      top: 0;
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background: red;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}

.config {
  span {
    margin-right: 10px;
  }
}

.card_page:not(:first-child) {
  margin-top: 20px;
}
</style>
